import { SET_STORE_DETAILS } from './types';

const initialState = {
  storeQr: '',
  storeId: '',
  storeName: '',
  storeMasterId: '',
};

export const storeQrReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STORE_DETAILS:
      return {
        ...state,
        storeId: action.payload.store_id,
        storeName: action.payload.store_name,
        storeMasterId: action.payload.store_master_id,
      };
    default:
      return state;
  }
};
